import { render, staticRenderFns } from "./PreviewCampMail.vue?vue&type=template&id=dcd80a68&scoped=true&"
import script from "./PreviewCampMail.vue?vue&type=script&lang=js&"
export * from "./PreviewCampMail.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCampMail.vue?vue&type=style&index=0&id=dcd80a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd80a68",
  null
  
)

export default component.exports